/**
 * @desc 获取详情(调整，子列表去除，[上级组织]直接取deptParentName字段)
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/organization/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
